import { webCrypto } from '#web-crypto';
import { base64ToArray, stringToArray } from './binary-utils';
import { PASSWORD_DERIVE_HASH_FUNCTION } from './constants';
import { pbkdf2DeriveAesKey } from './pbkdf2';
export const importPassword = async (password) => {
    const passwordBuffer = new Uint8Array(stringToArray(password.normalize()));
    const importedPassword = webCrypto.subtle.importKey('raw', passwordBuffer, 'PBKDF2', false, ['deriveBits', 'deriveKey']);
    const size = passwordBuffer.byteLength;
    passwordBuffer.fill(0, size);
    return importedPassword;
};
export const derivePasswordKey = async (password, iterations, salt) => {
    const importedPassword = await importPassword(password);
    const passwordKey = await pbkdf2DeriveAesKey(importedPassword, base64ToArray(salt), iterations, PASSWORD_DERIVE_HASH_FUNCTION);
    return passwordKey;
};
